import { render, staticRenderFns } from "./AddUserDialog.vue?vue&type=template&id=48fa5346&scoped=true"
import script from "./AddUserDialog.vue?vue&type=script&lang=js"
export * from "./AddUserDialog.vue?vue&type=script&lang=js"
import style0 from "./AddUserDialog.vue?vue&type=style&index=0&id=48fa5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa5346",
  null
  
)

export default component.exports